<template>
  <section class="awards-recognition-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i class="fas fa-trophy"></i>
          <span>{{ content.header.tag }}</span>
        </div>
        <h2>{{ content.header.title }}</h2>
        <p class="section-description">{{ content.header.description }}</p>
      </div>
    </div>
    
    <div class="awards-slider swiper" ref="awardsSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(award, index) in content.items" :key="index">
          <div class="award-card">
            <div class="award-image-container">
              <img :src="award.image" :alt="award.title" class="award-image" />
              <div class="award-overlay">
                <div class="award-badge">
                  <i class="fas fa-trophy"></i>
                  <span>Winner</span>
                </div>
                <div class="award-content">
                  <h3 class="award-title">{{ award.title }}</h3>
                  <p class="award-category">{{ award.category }}</p>
                  <p class="award-date">{{ award.date }}</p>
                  <div class="award-tags">
                    <span v-for="(tag, tagIndex) in award.tags" :key="tagIndex" class="award-tag">{{ tag }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: 'FullScreenSmoothSliderComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup() {
    const awardsSwiper = ref(null)

    const initAwardsSwiper = () => {
      setTimeout(() => {
        const checkSwiper = () => {
          if (window.Swiper) {
            awardsSwiper.value = new window.Swiper('.awards-slider', {
              loop: true,
              autoplay: {
                delay: 0,
                disableOnInteraction: false,
              },
              speed: 5000,
              effect: 'slide',
              allowTouchMove: false,
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              },
            })
          } else {
            setTimeout(checkSwiper, 100)
          }
        }
        checkSwiper()
      }, 100)
    }

    onMounted(() => {
      initAwardsSwiper()
    })

    return {
      awardsSwiper
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Awards & Recognition Section */
.awards-recognition-section {
  padding: 120px 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  position: relative;
  overflow: hidden;
}

.awards-recognition-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #FB0E76, #910694);
  color: #fff;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.section-tag i {
  font-size: 10px;
}

.section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.section-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Swiper Styles */
.awards-slider {
  padding: 0 20px;
}

.award-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.award-card:hover {
  transform: translateY(-10px);
  border-color: rgba(251, 14, 118, 0.3);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.award-image-container {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.award-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.award-card:hover .award-image {
  transform: scale(1.1);
}

.award-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(251, 14, 118, 0.9), rgba(145, 6, 148, 0.9));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.award-card:hover .award-overlay {
  opacity: 1;
}

.award-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-self: flex-start;
}

.award-badge i {
  font-size: 14px;
}

.award-content {
  text-align: center;
  color: #fff;
}

.award-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
  line-height: 1.3;
}

.award-category {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 5px;
  font-weight: 500;
}

.award-date {
  font-size: 12px;
  opacity: 0.8;
  margin-bottom: 15px;
  font-weight: 600;
}

.award-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

.award-tag {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive Design */
@media (max-width: 991px) {
  .awards-recognition-section {
    padding: 80px 0;
  }
  
  .section-header h2 {
    font-size: 42px;
  }
  
  .section-description {
    font-size: 16px;
  }
  
  .award-image-container {
    height: 220px;
  }
}

@media (max-width: 767px) {
  .section-header h2 {
    font-size: 36px;
  }
  
  .award-image-container {
    height: 200px;
  }
  
  .award-overlay {
    padding: 15px;
  }
  
  .award-title {
    font-size: 16px;
  }
  
  .award-category {
    font-size: 13px;
  }
  
  .award-date {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-description {
    font-size: 14px;
  }
  
  .award-image-container {
    height: 180px;
  }
  
  .award-overlay {
    padding: 12px;
  }
  
  .award-title {
    font-size: 14px;
  }
  
  .award-category {
    font-size: 12px;
  }
  
  .award-date {
    font-size: 10px;
  }
  
  .award-badge {
    padding: 6px 12px;
    font-size: 10px;
  }
  
  .award-tag {
    font-size: 9px;
    padding: 3px 6px;
  }
}
</style>
